import { z } from 'zod';
import { AllPaymentProviderSchema } from '../common-tools/providers';
import { BillingCycleAnchorSchema, BillingHistoryStatusSchema, BillingIntervalSchema, RecurringPlanStatusSchema, SubscriptionStatusSchema, } from './enums';
// Configuration schemas
export const PlanConfigurationsSchema = z
    .record(z.string(), z.unknown())
    .nullable();
export const SubscriptionConfigurationsSchema = z
    .record(z.string(), z.unknown())
    .nullable();
// Recurring Plan - Internal (full schema)
export const RecurringPlanSchema = z.object({
    id: z.string(),
    businessId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    interval: BillingIntervalSchema,
    intervalCount: z.number(),
    amount_cents: z.number(),
    currency: z.string(),
    trialPeriodDays: z.number().nullable(),
    billingCycleAnchor: BillingCycleAnchorSchema,
    maxCycles: z.number().nullable(),
    isActive: z.boolean(),
    status: RecurringPlanStatusSchema,
    configurations: PlanConfigurationsSchema,
    metadata: z.unknown().nullable(),
    // customers using this plan
    currentInUseBy: z.string().array(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    deletedAt: z.coerce.date().nullable(),
});
// Customer Recurring Subscription - Internal (full schema)
export const CustomerRecurringSubscriptionSchema = z.object({
    id: z.string(),
    businessId: z.string(),
    customerId: z.string(),
    recurringPlanId: z.string(),
    paymentMethodId: z.string(),
    status: SubscriptionStatusSchema,
    currentPeriodStart: z.coerce.date(),
    currentPeriodEnd: z.coerce.date(),
    nextBillingDate: z.coerce.date(),
    amount_cents: z.number(),
    cycleCount: z.number(),
    totalPaid_cents: z.number(),
    trialStart: z.coerce.date().nullable(),
    trialEnd: z.coerce.date().nullable(),
    cancelAtPeriodEnd: z.boolean(),
    cancelledAt: z.coerce.date().nullable(),
    cancellationReason: z.string().nullable(),
    provider: AllPaymentProviderSchema,
    providerSubscriptionId: z.string().nullable(),
    metadata: z.unknown().nullable(),
    configurations: SubscriptionConfigurationsSchema,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    deletedAt: z.coerce.date().nullable(),
});
// Subscription Billing History - Internal (full schema)
export const SubscriptionBillingHistorySchema = z.object({
    id: z.string(),
    businessId: z.string(),
    subscriptionId: z.string(),
    salesId: z.string().nullable(),
    paymentTransactionId: z.string().nullable(),
    billingDate: z.coerce.date(),
    periodStart: z.coerce.date(),
    periodEnd: z.coerce.date(),
    amount_cents: z.number(),
    status: BillingHistoryStatusSchema,
    attemptCount: z.number(),
    lastAttemptDate: z.coerce.date(),
    nextRetryDate: z.coerce.date().nullable(),
    failureReason: z.string().nullable(),
    failureCode: z.string().nullable(),
    provider: AllPaymentProviderSchema,
    providerInvoiceId: z.string().nullable(),
    metadata: z.unknown().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    deletedAt: z.coerce.date().nullable(),
});
